<template>
  <button
    type="button"
    class="inline font-semibold antialiased px-1.5 py-1 -mx-1.5 -my-1 rounded-md transition-colors"
    :class="{
      'text-blue-600 hover:bg-blue-50 font-semibold antialiased': intent === 'link',
      'text-gray-700 hover:bg-gray-100': intent === 'button',
    }"
    v-bind="{ ...$attrs, ...$props }"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "InlineButton",

  props: {
    // intent shows how the button acts, link is for opening modals etc., button is for CopyButton etc.
    intent: {
      type: String,
      validator: (v) => ["link", "button"].includes(v),
      default: "link",
    },
  },
};
</script>
